import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/ui-custom/Reveal";
import { SERVICE_LIST } from "@/content/services";

const BLURB = {
  "private-label": "Own-brand sliced deli meats and deli products, sliced, packed and labelled in our Sydney slice house for supermarkets and grocers.",
  processing: "SQF accredited high care slicing and packing of deli meats, smallgoods and cheese into retail-ready and foodservice formats.",
  foodservice: "Wholesale deli meats, Italian cheese, pasta, olive oil and pantry lines delivered chilled to cafes, restaurants and pizzerias.",
  "brand-distribution": "Retail and grocery distribution for Australian and imported food brands into independent supermarkets, delis and foodservice.",
};

export const ServicesSection = () => (
  <section id="services" className="py-20 lg:py-28 bg-[var(--cream)]" data-testid="services-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <SectionHeading eyebrow="What we do" title="More than a wholesale food supplier" />
          <Reveal delay={0.2}>
            <p className="mt-6 text-[var(--charcoal)] font-light leading-relaxed">Deliver combines food distribution across Sydney, NSW, the ACT and south-east Queensland with an SQF accredited high care slice house in Mount Druitt. That means independent retailers can source premium Australian and imported ranges, retail-ready deli meats and private label deli products from a single supplier, while cafes and restaurants get a foodservice distributor that understands Italian and gourmet ingredients.</p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 lg:gap-5">
          {SERVICE_LIST.map((s, i) => (
            <Reveal key={s.slug} delay={0.1 + i * 0.08}>
              <Link to={s.path} className="group block h-full border border-[var(--sand)] rounded-sm p-6 lg:p-7 hover:border-[var(--ink)] hover:bg-white transition-colors" data-testid={`service-card-${s.slug}`}>
                <div className="flex items-start justify-between gap-4">
                  <p className="eyebrow text-[var(--terracotta)]">{String(i + 1).padStart(2, "0")}</p>
                  <ArrowUpRight size={18} className="opacity-40 group-hover:opacity-100 group-hover:text-[var(--terracotta)] transition-all" />
                </div>
                <h3 className="font-display font-normal text-xl sm:text-2xl mt-4 text-[var(--ink)] leading-tight">{s.navLabel}</h3>
                <p className="mt-3 text-sm text-[var(--charcoal)] font-light leading-relaxed">{BLURB[s.slug]}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
